module.exports = __webpack_public_path__ + "static/media/importICloud2.1b5a6dcc.png";